import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";
import React from "react";
import { AROM_ASSESSMENT } from "../models/Enums";
import { AssessmentKey } from "./modals/arom-assessment-gif";

const AromAssessmentCounterRight = () => {
  const ref = React.createRef<HTMLDivElement>();
  setInterval(() => {
    let assessment = sessionStorage.getItem(
      "aromAssessmentIndex"
    ) as AROM_ASSESSMENT;
    let right_value = document.getElementById(
      "arom-realtime-angle-right-value"
    );
    let num = Number(right_value?.innerText.slice(0, -1));
    if (!ref.current) return;
    let normalizesValue = 0;
    if (
      assessment === AROM_ASSESSMENT.Shoulder_AAA ||
      assessment === AROM_ASSESSMENT.Left_Shoulder_FAE ||
      assessment === AROM_ASSESSMENT.Right_Shoulder_FAE
    ) {
      // the constant values used below are to convert 0 to 180 range into 100 to 25 (needed to drive the circle)
      normalizesValue = (-5 / 12) * num + 100;
    } else if (
      assessment === AROM_ASSESSMENT.Left_Elbow_FAE ||
      assessment === AROM_ASSESSMENT.Right_Elbow_FAE
    ) {
      // the constant values used below are to convert 0 to 150 range into 100 to 25 (needed to drive the circle)
      normalizesValue = (-1 / 2) * num + 100;
    } else if (
      assessment === AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation ||
      assessment === AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation
    ) {
      // the constant values used below are to convert 0 to 90 range into 100 to 25 (needed to drive the circle)
      normalizesValue = (-5 / 6) * num + 100;
    }
    ref.current.style.setProperty("--progress", `${normalizesValue}%`);
  }, 25);

  return (
    <div className="precircularprogress">
      <div ref={ref} className="circularprogress">
        <span id="arom-realtime-angle-right-value">{"0°"}</span>
      </div>
    </div>
  );
};

export default AromAssessmentCounterRight;
